const optionAliases: Record<string, string> = {
  "FBA prep centre UK (Amazon)": "Amazon FBA Prep",
};

export function normalizeFulfillmentOptionName(optionName: string): string {
  const trimmedOptionName = optionName.trim();
  return optionAliases[trimmedOptionName] ?? trimmedOptionName;
}
